(function () {
  'use strict';
  if (customElements.get('sissilux-home-bfcm')) return;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const unique = list => (list || []).filter((g, i, all) => g && all.findIndex(x => x.variantId === g.variantId) === i);
  const name = g => g.type || g.name || '';
  const url = value => {
    if (typeof value !== 'string' || /[\\\u0000-\u001f]/.test(value)) return '';
    if (/^\/(?!\/)/.test(value)) return value;
    try { const u = new URL(value.startsWith('//') ? 'https:' + value : value); return u.protocol === 'https:' && !u.username && !u.password ? u.href : ''; } catch (_) { return ''; }
  };
  class HomeBfcm extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.copy = JSON.parse(this.querySelector('[data-home-copy]').textContent);
      this.nativeFormReady = !!customElements.get('product-form');
      customElements.whenDefined('product-form').then(() => {
        if (!this.isConnected) return;
        this.nativeFormReady = true;
        this.renderSet();
      });
      this.refresh = () => this.render();
      this.addEventListener('click', event => {
        const scroll = event.target.closest('[data-home-gift-scroll]');
        if (scroll) {
          const rail = this.querySelector('[data-home-details]');
          rail.scrollBy({left:Number(scroll.dataset.homeGiftScroll) * rail.clientWidth * .85,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          return;
        }
        if (event.target.closest('[data-home-expand]')) {
          this.querySelector('[data-home-products]').classList.add('is-expanded');
          this.querySelector('[data-home-expand]').setAttribute('aria-expanded', 'true');
          this.queueSticky();
          return;
        }
        if (event.target.closest('[data-sticky-add]')) {
          const submit = this.querySelector('[data-home-form] [type="submit"]');
          if (!submit.disabled && submit.getAttribute('aria-disabled') !== 'true' && !submit.classList.contains('loading')) submit.click();
          return;
        }
        const button = event.target.closest('[data-home-select]');
        if (!button || button.disabled) return;
        const card = button.closest('[data-home-product]');
        card.classList.toggle('is-selected');
        const selected = card.classList.contains('is-selected');
        button.setAttribute('aria-pressed', String(selected));
        button.textContent = this.t(selected ? 'selected' : 'select');
        card.querySelector('.shb__quantity').hidden = !selected;
        this.renderSet();
      });
      this.addEventListener('change', event => {
        const card = event.target.closest('[data-home-product]');
        if (!card) return;
        if (event.target.matches('[data-home-variant]')) {
          const option = event.target.selectedOptions[0], input = card.querySelector('[data-home-quantity]');
          input.min = option.dataset.min; input.step = option.dataset.step; input.value = option.dataset.min;
          if (option.dataset.max) input.max = option.dataset.max; else input.removeAttribute('max');
          card.querySelector('[data-home-price]').textContent = this.money(Number(option.dataset.price));
        }
        this.renderSet();
      });
      this.addEventListener('input', event => { if (event.target.matches('[data-home-quantity]')) this.renderSet(); });
      this.addEventListener('submit', event => {
        if (!event.target.matches('[data-home-form]')) return;
        // Shrine enables its single-product ID during upgrade. This form submits
        // only the selected items[]; an empty id makes Shopify reject the request.
        event.target.querySelector('[name="id"]').disabled = true;
        this.renderSet();
        const invalid = this.selection().find(item => !item.valid);
        if (!this.nativeFormReady || !this.selection().length || invalid) { event.preventDefault(); event.stopImmediatePropagation(); invalid?.input.reportValidity(); }
      }, true);
      document.addEventListener('sissilux:promotion-updated', this.refresh);
      document.addEventListener('sissilux:discounts-updated', this.refresh);
      this.setupSticky();
      this.render();
    }
    disconnectedCallback() {
      document.removeEventListener('sissilux:promotion-updated', this.refresh);
      document.removeEventListener('sissilux:discounts-updated', this.refresh);
      window.removeEventListener('scroll', this.queueSticky);
      window.removeEventListener('resize', this.queueSticky);
      this.stickyObserver?.disconnect();
      this.stickySizeObserver?.disconnect();
      this.stickyPageObserver?.disconnect();
      cancelAnimationFrame(this.stickyFrame);
      this.ready = false;
    }
    setupSticky() {
      this.sticky = this.querySelector('[data-home-sticky]');
      if (!this.sticky) return;
      this.queueSticky = () => {
        if (this.stickyFrame) return;
        this.stickyFrame = requestAnimationFrame(() => { this.stickyFrame = 0; this.updateSticky(); });
      };
      window.addEventListener('scroll', this.queueSticky, {passive:true});
      window.addEventListener('resize', this.queueSticky, {passive:true});
      this.stickyObserver = new MutationObserver(this.queueSticky);
      this.stickyObserver.observe(this.querySelector('product-form'), {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','hidden']});
      this.stickySizeObserver = new ResizeObserver(this.queueSticky);
      this.stickySizeObserver.observe(this.querySelector('.shb__shopping'));
      this.stickyPageObserver = new MutationObserver(this.queueSticky);
      this.stickyPageObserver.observe(document.body, {childList:true});
      this.queueSticky();
    }
    updateSticky() {
      if (!this.sticky || !this.isConnected) return;
      const products = this.querySelector('[data-home-products]'), expand = this.querySelector('[data-home-expand]');
      const limit = window.innerWidth <= 600 ? 4 : window.innerWidth <= 900 ? 6 : 8;
      expand.hidden = products.classList.contains('is-expanded') || products.children.length <= limit;
      const main = this.querySelector('[data-home-form] [type="submit"]'), button = this.querySelector('[data-sticky-add]');
      const busy = main.classList.contains('loading') || main.getAttribute('aria-disabled') === 'true';
      button.disabled = main.disabled || busy;
      button.setAttribute('aria-busy', String(busy));
      const error = this.querySelector('.product-form__error-message-wrapper'), stickyError = this.querySelector('[data-sticky-error]');
      stickyError.hidden = error.hidden || !error.textContent.trim();
      stickyError.textContent = stickyError.hidden ? '' : error.textContent.trim();
      const area = this.querySelector('.shb__shopping').getBoundingClientRect(), rect = main.getBoundingClientRect();
      const previewBar = document.getElementById('PBarNextFrameWrapper');
      if (previewBar && previewBar !== this.previewBar) { this.previewBar = previewBar; this.stickySizeObserver.observe(previewBar); }
      const previewRect = previewBar?.getBoundingClientRect();
      const offset = previewRect?.height > 0 ? Math.max(0, window.innerHeight - previewRect.top) : 0;
      this.sticky.style.bottom = offset + 'px';
      const nativeVisible = rect.top < window.innerHeight - offset && rect.bottom > 0;
      const consentVisible = document.getElementById('shopify-pc__banner')?.getClientRects().length > 0;
      this.sticky.hidden = this.hidden || consentVisible || this.querySelector('[data-home-set]').hidden || area.top >= window.innerHeight - offset - 80 || area.bottom <= 80 || nativeVisible;
    }
    t(key, args = {}) { return String(this.copy[key] || '').replace(/\{(\w+)\}/g, (_, k) => args[k] ?? ''); }
    money(cents) { return new Intl.NumberFormat(this.program.locale || 'en', {style:'currency',currency:this.program.currency, maximumFractionDigits: Number(cents) % 100 ? 2 : 0}).format(cents / 100); }
    image(gift) {
      let src = url(gift?.image), responsive = '';
      if (!src) return '';
      const asset = new URL(src, window.location.origin);
      // Shared reward data contains a small thumbnail. Request responsive CDN
      // sizes for these larger cards without changing the configured artwork.
      if ((asset.origin === window.location.origin && asset.pathname.startsWith('/cdn/shop/')) ||
          (asset.hostname === 'cdn.shopify.com' && asset.pathname.startsWith('/s/files/'))) {
        const resized = width => { const candidate = new URL(asset); candidate.searchParams.set('width', width); return candidate.href; };
        src = resized(640);
        responsive = ' srcset="' + esc([320,480,640,960,1254].map(width => resized(width) + ' ' + width + 'w').join(', ')) + '" sizes="auto, (max-width:600px) 148px, 420px"';
      }
      return '<img src="' + esc(src) + '"' + responsive + ' alt="' + esc(name(gift)) + '" width="320" height="320" loading="lazy" decoding="async">';
    }
    result(tier) { return window.SissiluxPromotionRules.evaluate(this.program, tier.minQuantity); }
    info(result) {
      const info = window.SissiluxPromotionRules.rewardInfo(result);
      return {...info, available:info.choices};
    }
    describe(result) {
      const info = this.info(result), parts = [info.count ? window.SissiluxPromotionRules.choiceCopy(this.program,result).compact : this.t('sold_out')];
      if (result.giftCardValueCents > 0) parts.push(this.money(result.giftCardValueCents) + ' ' + this.t('gift_card'));
      return parts.join(' + ');
    }
    render() {
      const rules = window.SissiluxPromotionRules;
      const shared = window.SissiluxDiscounts;
      this.lowPrice = shared?.profile?.enabled === true;
      if (this.lowPrice) {this.program={enabled:true,currency:shared.profile.currency,locale:document.documentElement.lang||'en',eligibleQuantity:0};this.hidden=false;this.renderSet();return;}
      if (!rules) return;
      let local; try { local = JSON.parse(this.querySelector('[data-siss-promotion-program]').textContent); } catch (_) { return; }
      const current = rules.readProgram(this);
      this.program = current && current.country === local.country && current.currency === local.currency ? current : local;
      const tiers = (this.program.tiers || []).filter(t => t.enabled && t.minQuantity > 0).sort((a,b) => a.minQuantity - b.minQuantity);
      this.hidden = !this.program.enabled || !tiers.length;
      if (this.hidden) return;
      const signature = JSON.stringify([this.program.country,this.program.currency,this.program.eligibleSubtotalUsdCents,this.program.basicGifts,tiers]);
      if (this.signature !== signature) {
        this.signature = signature;
        this.querySelector('[data-home-tiers]').innerHTML = tiers.map((tier, i) => {
          const result = this.result(tier);
          return '<article class="shb__rule"><div class="shb__rule-line"><strong>' + esc(this.t('buy')) + ' ' + esc(tier.minQuantity) + (i === tiers.length - 1 && tiers.length > 1 ? '+' : '') + '</strong><span class="siss-regional-tier" data-campaign-tier data-minimum="' + tier.minQuantity + '" hidden></span></div><p>' + esc(this.t(i ? 'more_choices' : 'choose_one')) + (result.giftCardValueCents > 0 ? ' + ' + esc(this.money(result.giftCardValueCents)) + ' ' + esc(this.t('gift_card')) : '') + '</p></article>';
        }).join('');
        const gifts = unique(tiers.flatMap(t => this.result(t).choiceGifts));
        const second = tiers[1];
        this.querySelector('[data-home-details]').innerHTML = gifts.map(g => {
          const minimum = tiers.find(t => this.result(t).choiceGifts.some(x => String(x.variantId) === String(g.variantId)))?.minQuantity || 1;
          const href = url(g.url), photo = this.image(g);
          return '<article class="shb__gift" data-home-gift data-minimum="' + minimum + '"><span class="shb__gift-condition">' + esc(this.t('free_with',{quantity:minimum})) + '</span>' + (href ? '<a class="shb__gift-image" href="' + esc(href) + '">' + photo + '</a>' : '<div class="shb__gift-image">' + photo + '</div>') + '<h3>' + (href ? '<a href="' + esc(href) + '">' + esc(name(g)) + '</a>' : esc(name(g))) + '</h3>' + (g.valueCents > 0 ? '<p class="shb__gift-value">' + esc(this.t('worth')) + ' <strong>' + esc(this.money(g.valueCents)) + '</strong></p>' : '') + (!g.available ? '<strong class="shb__stock">' + esc(this.t('sold_out')) + '</strong>' : g.showStock && Number.isInteger(g.manualStock) ? '<span class="shb__stock">' + esc(this.t('only_left',{count:g.manualStock})) + '</span>' : '') + (href ? '<a class="shb__gift-link" href="' + esc(href) + '">' + esc(this.t('view_details')) + '</a>' : '') + '</article>';
        }).join('');
        const upgradeText = this.querySelector('[data-home-upgrade]');
        if (upgradeText) upgradeText.textContent = second ? this.t('buy') + ' ' + second.minQuantity + ' · ' + this.describe(this.result(second)) : this.t('mix');
      }
      this.renderSet();
    }
    selection() {
      return [...this.querySelectorAll('[data-home-product].is-selected')].map(card => {
        const option = card.querySelector('[data-home-variant]').selectedOptions[0], input = card.querySelector('[data-home-quantity]'), quantity = Number(input.value);
        return {id:option.value, product_id:Number(card.dataset.productId), quantity, price:Number(option.dataset.price), compare_at_price:Number(option.dataset.compare)||0, input, valid:!option.disabled && input.checkValidity() && Number.isSafeInteger(quantity) && quantity > 0};
      });
    }
    renderCardPrices(lines) {
      const discounts = window.SissiluxDiscounts, policy = discounts?.policy;
      if (!policy) return;
      const cart = discounts.cart, existing = cart?.currency === this.program.currency ? cart.items : [];
      for (const card of this.querySelectorAll('[data-home-product]')) {
        const node = card.querySelector('[data-home-price]'), option = card.querySelector('[data-home-variant]').selectedOptions[0];
        if (!node || !option) continue;
        const item = {id:option.value, product_id:Number(card.dataset.productId), price:Number(option.dataset.price), compare_at_price:Number(option.dataset.compare)||0, quantity:Number(option.dataset.min) || 1};
        const index = lines.findIndex(line => line.id === item.id && line.product_id === item.product_id);
        const candidates = index >= 0 ? lines : [...lines, item];
        const quote = option.disabled ? null : policy.quote(candidates, existing);
        const percent = quote?.rates[index >= 0 ? index : candidates.length - 1] || 0;
        const base = policy.basePrice ? policy.basePrice(item) : item.price, reference = policy.referencePrice ? policy.referencePrice(item) : item.price;
        const current = policy.price(base, percent), discounted = current < reference;
        const html = '<span class="shb__price-current">' + esc(this.money(current)) + '</span>' + (discounted ? '<del class="shb__price-base">' + esc(this.money(reference)) + '</del><small class="shb__price-discount">' + esc(percent ? this.t('extra_short', {percent}) : 'SAVE ' + this.money(reference-current)) + '</small>' : '');
        if (node.innerHTML !== html) node.innerHTML = html;
      }
    }
    renderSet() {
      if (!this.program || !this.querySelector('[data-home-set]')) return;
      const selected = this.selection(), valid = selected.length > 0 && selected.every(i => i.valid);
      const lines = selected.filter(i => i.valid), count = lines.reduce((n,i) => n+i.quantity,0);
      const original = lines.reduce((n,i) => n+i.quantity*i.price,0);
      const discounts = window.SissiluxDiscounts, cart = discounts?.cart;
      const quote = discounts?.policy?.quote(lines, cart?.currency === this.program.currency ? cart.items : []);
      const total = quote?.total ?? original;
      this.renderCardPrices(lines);
      this.querySelector('[data-home-set]').hidden = !selected.length;
      this.querySelector('[data-home-count]').textContent = this.t('count',{count});
      this.querySelector('[data-home-total]').textContent = this.money(total);
      const campaign = this.querySelector('siss-promotion-layers');
      campaign?.setAttribute('data-added-quantity', String(count));
      campaign?.setAttribute('data-added-value', String(original));
      const result = this.lowPrice ? null : window.SissiluxPromotionRules.project(this.program,count,lines);
      this.querySelector('[data-home-reward]').textContent = this.lowPrice ? (quote?.percent ? 'Extra '+quote.percent+'% OFF applied' : 'Buy any 2 devices for extra savings') : result ? this.describe(result) : this.t('none');
      this.querySelector('[data-home-context]').textContent = result ? this.t('projected',{count:result.eligibleQuantity}) : '';
      const inputs = this.querySelector('[data-home-inputs]'); inputs.replaceChildren();
      if (valid) selected.forEach((item,index) => { for (const key of ['id','quantity']) { const input = document.createElement('input'); input.type='hidden'; input.name='items['+index+']['+key+']'; input.value=item[key]; inputs.append(input); } });
      this.querySelector('[type="submit"]').disabled = !valid || !this.nativeFormReady;
      if (this.sticky) {
        this.querySelector('[data-sticky-count]').textContent = this.t('count',{count});
        this.querySelector('[data-sticky-total]').textContent = this.money(total);
        this.querySelector('[data-sticky-reward]').textContent = this.lowPrice ? this.querySelector('[data-home-reward]').textContent : result ? this.describe(result) : this.t('none');
        this.queueSticky();
      }
    }
  }
  customElements.define('sissilux-home-bfcm',HomeBfcm);
})();

